module.exports = {
  "default": require("core-js/library"),
  __esModule: true
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js.js
 ** module id = 636
 ** module chunks = 0
 **/